import { HttpClient } from '../core/request'
import { dateDifInHours } from '../routes/LocalDeals/helpers/dateTimeHelper'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_WALLET_ITEMS_QTY = 'SET_WALLET_ITEMS_QTY';

// ------------------------------------
// Actions
// ------------------------------------
export function setWalletItemsQty(itemsQty) {
    return {
        type: SET_WALLET_ITEMS_QTY,
        payload: itemsQty
    }
}

export function updateWalletItemsQty() {
    return (dispatch, getState) => {
        return HttpClient(true).get('/wallet').then(resp => {

            const count = resp.data.available.length;// + resp.data.expired.length;

            return dispatch({
                type: SET_WALLET_ITEMS_QTY,
                payload: (count)
            })
        })
    }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [SET_WALLET_ITEMS_QTY]: (state, action) => action.payload
};

// ------------------------------------
// Reducer
// ------------------------------------
export function walletItemsReducer(state = 0, action) {
    const handler = ACTION_HANDLERS[action.type];

    return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/walletItems.js